export default {"src":"/_next/static/media/scrollNext.3503a848.gif","height":500,"width":500,"blurWidth":0,"blurHeight":0};